module.exports = __webpack_public_path__ + "img/temp-heater-on.c8d9913e.svg";